var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GenericLayout',{staticClass:"fill-height",attrs:{"title":_vm.$t('TERMS_OF_SERVICE')}},[(_vm.$i18n.locale === 'es')?_c('TosEs'):_c('TosEn')],1)}
var staticRenderFns = []

export { render, staticRenderFns }